import React from 'react'
import { Routes, Route } from 'react-router-dom'

import PrivateRoute from './PrivateRoute'
import { roleObj } from './roles'

import AuthLayout from '../layouts/AuthLayout/AuthLayout'
import Login from '../pages/LoginPage/Login'
// import Register from '../pages/RegisterPage/Register'
// import AuthAction from '../pages/AuthActionPage/AuthAction'
// import ForgetPassword from '../pages/ForgetPasswordPage/ForgetPassword'
import AdminLayout from '../layouts/AdminLayout/AdminLayout'
import ConversationPage from '../pages/ConversationPage/ConversationPage'
import ConversationForm from '../pages/ConversationPage/Form'
import ImagePage from '../pages/ImagePage/ImagePage'
import ImageForm from '../pages/ImagePage/Form'
import VocabPage from '../pages/VocabPage/VocabPage'
import VocabForm from '../pages/VocabPage/Form'
import Forbidden from '../pages/403/Forbidden'
import NotFound from '../pages/404/NotFound'

const Index = () => {
  return (
    <Routes>
      {/* <Route path='/register' element={<Register />} /> */}
      <Route path='/' element={<AuthLayout />} >
        <Route index element={<Login />} />
        <Route path='login' element={<Login />} />
        {/* <Route path='auth/action' element={<AuthAction />} />
        <Route path='forget-password' element={<ForgetPassword />} /> */}
      </Route>
      <Route path='/admin' element={<AdminLayout />} >
        <Route
          path='conversations'
          element={
            <PrivateRoute roles={roleObj['view']['conversations']}>
              <ConversationPage />
            </PrivateRoute>
          }
        >
          <Route
            index
            element={<ConversationForm />}
          />
          <Route
            index
            element={
              <PrivateRoute roles={roleObj['view']['conversations']}>
                <ConversationForm />
              </PrivateRoute>
            }
          />
          {/* <Route
            path=':uid'
            element={
              <PrivateRoute roles={roleObj['edit']['conversations']}>
                <ConversationForm />
              </PrivateRoute>
            }
          /> */}
        </Route>
        <Route
          path='images'
          element={
            <PrivateRoute roles={roleObj['view']['images']}>
              <ImagePage />
            </PrivateRoute>
          }
        >
          <Route
            index
            element={<ImageForm />}
          />
          <Route
            index
            element={
              <PrivateRoute roles={roleObj['view']['images']}>
                <ImageForm />
              </PrivateRoute>
            }
          />
          {/* <Route
            path=':uid'
            element={
              <PrivateRoute roles={roleObj['edit']['images']}>
                <ImageForm />
              </PrivateRoute>
            }
          /> */}
        </Route>
        <Route
          path='vocab'
          element={
            <PrivateRoute roles={roleObj['view']['vocab']}>
              <VocabPage />
            </PrivateRoute>
          }
        >
          <Route
            index
            element={<VocabForm />}
          />
          <Route
            index
            element={
              <PrivateRoute roles={roleObj['view']['vocab']}>
                <VocabForm />
              </PrivateRoute>
            }
          />
          {/* <Route
            path=':uid'
            element={
              <PrivateRoute roles={roleObj['edit']['vocab']}>
                <VocabForm />
              </PrivateRoute>
            }
          /> */}
        </Route>
      </Route>
      <Route path='/403' element={<Forbidden />} />
      <Route path='/404' element={<NotFound />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  )
}

export default Index
